import {
  ShieldCheck,
  Crown,
  Eye,
  PencilSimple,
  ArrowsLeftRight,
  Icon,
  StarIcon,
  Star,
} from '@phosphor-icons/react'

export type FlagKey =
  | 'isAdmin'
  | 'isGuildMaster'
  | 'isGrowthWheelReviewer'
  | 'isGrowthWheelEditor'
  | 'staffAugmentation'
  | 'isLeadership'
export interface FlagDef {
  key: FlagKey
  label: string
  Icon: Icon
  weight: 'fill' | 'regular'
  color: string
  bg: string
}

export const FLAG_DEFS: FlagDef[] = [
  { key: 'isAdmin', label: 'Admin', Icon: ShieldCheck, weight: 'fill', color: '#7C3AED', bg: 'rgba(124,58,237,0.12)' },
  { key: 'isGuildMaster', label: 'Guild Master', Icon: Crown, weight: 'fill', color: '#D97706', bg: 'rgba(217,119,6,0.12)' },
  { key: 'isGrowthWheelReviewer', label: 'Growth Wheel Reviewer', Icon: Eye, weight: 'fill', color: '#0D9488', bg: 'rgba(20,184,166,0.12)' },
  { key: 'isGrowthWheelEditor', label: 'Growth Wheel Editor', Icon: PencilSimple, weight: 'fill', color: '#2563EB', bg: 'rgba(59,130,246,0.12)' },
  { key: 'staffAugmentation', label: 'Staff Augmentation Loan', Icon: ArrowsLeftRight, weight: 'regular', color: '#EA580C', bg: 'rgba(234,88,12,0.12)' },
  { key: 'isLeadership',  label: 'Leadership', Icon: Star, weight: 'fill', color: '#EC4899', bg: 'rgba(236,72,153,0.12)' },
]
